<template>
  <div class="quitSubtitleDialog">
    <div class="titleGrid">
      <div class="close-btn" @click="hide('Close')">
        <i class="icon-popup-close"></i>
      </div>
    </div>

    <div class="content">
      字幕保存成功！返回视频编辑后，如需修改字幕内容，可点击“添加字幕”继续编辑。
      添加字幕后如改动视频时长，有可能成字幕错位或丢失，请务必预览确认效果。
    </div>
    <div class="btnGrid">
      <div class="buleBtn" @click="hide('Ok')">知道了</div>
    </div>
    <div class="remind">
      <label>
        <input type="checkbox" v-model="noRemind" class="check-box" />
        <span></span>之后不再提醒
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "quitSubtitleDialog",
  data() {
    return {
      noRemind: false,
    };
  },
  props: {},
  components: {},
  methods: {
    hide(type) {
      this.$emit("resultHandler", { type: type, noRemind: this.noRemind });
    },
  },
  watch: {},
  computed: {},
};
</script>

<style scoped lang='scss'>
@import "./commonStyle";
.quitSubtitleDialog {
  position: relative;
  width: 540px;
  height: 303px;
  background: #fff;
  border-radius: 4px;

  .titleGrid {
    position: absolute;
    width: 100%;
    position: relative;
    height: 40px;

    .close-btn {
      position: absolute;
      top: 14px;
      right: 17px;
      cursor: pointer;
    }
  }

  .content {
    position: absolute;
    top: 61px;
    width: 100%;
    padding: 0 81px;
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
  }
  .btnGrid {
    position: absolute;
    margin: 0 auto;
    top: 158px;
    width: 100%;
    padding: 0 87px;
    display: flex;
    justify-content: center;
  }

  .remind {
    position: absolute;
    top: 227px;
    width: 100%;

    & > label {
      display: flex;
      align-items: center;
      justify-content: center;

      .check-box {
        display: none;
      }
      .check-box + span {
        width: 14px;
        height: 14px;
        border: 1px solid #000;
        display: inline-block;
        border-radius: 0px;
        margin-right: 8px;
      }
      .check-box:checked + span {
        background-color: #fff;
        position: relative;
      }
      .check-box:checked + span:after {
        content: "\2714";
        color: #000;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 10px;
      }

      font-size: 12px;
      color: #333333;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/subtitle/dialogs/quitSubtitleDialog.vue